import { Grid } from "@mui/material";
import React, { useState } from "react";
import InputField from "../../../../common/components/formFields/inputField/inputField";
import styles from "../addBulkCart.module.scss";
import { ToastNotification } from "../../../../common/components/toastNotification/ToastNotification";
import errorToast from "../../../../assets/images/errorToast.svg";
import successToast from "../../../../assets/images/successToast.svg";
import { generateHashedPassword } from "../../../../utils/functions";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { useAxios } from "../../../../services/useAxios";
import {
  APIMethods,
  loginRoutes,
} from "../../../../common/constants/urlConstants";
import { useDispatch } from "react-redux";
import { updateIsLoading } from "../../../../reducerSlices/loaderSlice";
import Button from "../../../../common/components/button/Button";
import { constants } from "../../../../common/constants/constants";
import { yupResolver } from "@hookform/resolvers/yup";
import { useAddBulkCartContext } from "../context/addBulkCartContext";

function BuyerCredentialForm() {
  const [toastData, setToastData] = useState(constants.defaultToastData);
  const dispatch = useDispatch();
  const { setAccessToken, setOutlets, setUserId, resetContext } =
    useAddBulkCartContext();

  const schema = yup.object().shape({
    email: yup
      .string()
      .required("Enter Email Id")
      .matches(constants.formaValidations.EMAIL_REGEX, "Invalid Email format"),
    password: yup.string().required("Enter password"),
  });

  const {
    register,
    formState: { errors, isSubmitted },
    handleSubmit,
    setValue,
    watch,
    getValues,
    reset,
    trigger,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const signIn = useAxios({
    axiosParams: {
      url: loginRoutes.userSignin,
      data: {
        email: watch("email"),
        password: generateHashedPassword(watch("password")), // watch("password")
      },
    },
    method: APIMethods.post,
  });

  const onSubmit = async (data: any) => {
    dispatch(updateIsLoading(true));
    const response: any = await signIn.fetchData();
    if (response?.accessToken) {
      if (
        response.data.business_details.length &&
        response.data.business_details[0].role_key?.includes("buyer")
      ) {
        setUserId(response?.data?.id);
        setAccessToken(response?.accessToken);
        const outlets = response.data.business_details.map((business: any) => ({
          id: business.business_store_id,
          name: business.saved_as,
          cartId: business.cart_id,
        }));
        setOutlets(outlets);
      } else {
        resetContext();
        setToastData({ message: "Not a buyer account", status: "Fail" });
        setTimeout(() => {
          setToastData(constants.defaultToastData);
        }, 5000);
      }
      dispatch(updateIsLoading(false));
      reset();
      setTimeout(() => {
        setToastData(constants.defaultToastData);
      }, 2000);
    } else {
      setAccessToken("");
      let errorMessage =
        response?.response?.data?.error_msg ??
        "Oops! Something went wrong. Please retry.";
      setToastData({ message: errorMessage, status: "Fail" });
      setTimeout(() => {
        setToastData(constants.defaultToastData);
      }, 5000);
      dispatch(updateIsLoading(false));
    }
  };

  const onChangeField = React.useCallback(
    (name: any) => (text: any) => {
      setValue(name, text);
      isSubmitted && trigger(name);
    },
    [setValue, isSubmitted]
  );

  const handleKeyPress = (event: any) => {
    if (
      event.key === "Enter" &&
      getValues()?.email &&
      getValues()?.email?.length > 0 &&
      getValues()?.password &&
      getValues()?.password?.length > 0
    ) {
      if (onSubmit) {
        onSubmit({
          email: getValues().email,
          password: getValues().password,
        });
      }
    }
  };

  return (
    <>
      {toastData?.message && (
        <ToastNotification
          icon={toastData.status === "Success" ? successToast : errorToast}
          content={toastData?.message}
          position={"top-right"}
          autoClose={2000}
          handleClose={() => setToastData(constants.defaultToastData)}
        />
      )}
      <Grid
        container
        flexDirection="column"
        gap="8px"
        style={{
          backgroundColor: "#FFFFFF",
          padding: "20px",
          borderRadius: "8px",
          boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.1)",
          maxWidth: "400px",
          marginBottom: "16px",
        }}
      >
        <form>
          {/* // <!-- email --> */}
          <div
            className={`${styles.email} ${styles.formField}`}
            style={{ marginBottom: "16px" }}
          >
            <div className={styles.formFieldItem}>
              <div className={styles.label}>email ID</div>
              <InputField
                placeholder={"email"}
                onChange={onChangeField("email")}
                register={register("email")}
                errorMessage={errors.email?.message}
                autoComplete={false}
              />
            </div>
          </div>
          {/* <!-- email --> */}

          {/* <!-- password --> */}
          <div
            className={`${styles.password} ${styles.formField}`}
            style={{ marginBottom: "16px" }}
          >
            <div className={styles.formFieldItem}>
              <div className={styles.label}>password</div>
              <div className={styles.formFieldPassword} id="password-field">
                <InputField
                  enterCall={true}
                  handleKeyPress={handleKeyPress}
                  placeholder={"password"}
                  type="password"
                  onChange={onChangeField("password")}
                  register={register("password")}
                  errorMessage={errors.password?.message}
                />
              </div>
            </div>
          </div>
          {/* <!-- password --> */}

          {/* <!-- Remember me section --> */}

          {/* // <!-- Remember me section --> */}
          <div
            className={`${styles.formField} ${styles.formField}`}
            id="button-signin"
          >
            <Button
              label="check"
              large={true}
              handleClick={handleSubmit(onSubmit)}
              type="submit"
            />
          </div>
        </form>
      </Grid>
    </>
  );
}
export default BuyerCredentialForm;
